import { LineOfBusinessConfig } from "../claimsSearchBar/legacySearchBarSupport";
import { SEARCH_PARAMETERS } from "../searchResults/constants";
import { ROUTES, ISO_COUNTRY_CODES } from "src/app/constants";
import { Role } from "src/auth/types/interfaces";

// Country code type for WC claims filtering (ISO 3166-1 alpha-2)
export type CountryCode = "US" | "CA";

// Country option definitions for the country filter dropdown
export const COUNTRY_OPTIONS = [
  {
    label: "United States",
    value: ISO_COUNTRY_CODES.UNITED_STATES as CountryCode,
  },
  { label: "Canada", value: ISO_COUNTRY_CODES.CANADA as CountryCode },
] as const;

// Role to country code mapping
export const ROLE_TO_COUNTRY_MAP: Record<string, CountryCode | undefined> = {
  [Role.WC_CLAIM_USER]: ISO_COUNTRY_CODES.UNITED_STATES,
  [Role.WC_CLAIM_CANADA_USER]: ISO_COUNTRY_CODES.CANADA,
};

// Workers Compensation specific search configuration
export const WC_LINE_OF_BUSINESS_CONFIG: LineOfBusinessConfig = {
  searchByLabels: {
    [SEARCH_PARAMETERS.ALIAS]: {
      buttonText: "Search by Alias/Login",
      buttonTextSmall: "By Alias",
      placeholder: "Search for claims using the injured employee's alias/login",
      placeholderSmall: "Search using alias/login",
    },
    [SEARCH_PARAMETERS.EMPLOYEE_ID]: {
      buttonText: "Search by Employee ID",
      buttonTextSmall: "By EID",
      placeholder: "Search for claims using the injured employee's ID",
      placeholderSmall: "Search using Employee ID",
    },
    [SEARCH_PARAMETERS.SITE]: {
      buttonText: "Search by Incident Site",
      buttonTextSmall: "By Site",
      placeholder: "Search for claims using the Incident Site",
      placeholderSmall: "Search using Site",
    },
  },
  availableSearchParameters: [
    SEARCH_PARAMETERS.ALIAS,
    SEARCH_PARAMETERS.EMPLOYEE_ID,
    SEARCH_PARAMETERS.SITE,
  ],
  routePath: ROUTES.CLAIMS_HISTORY,
  metricsPrefix: "claims",
};
